// import axios from 'axios';
// import { SlackWebhook } from './utils';
import { UPDATE_LEAD_PAX_SUCCESS, UPDATE_LEAD_PAX_FAIL } from './types';
import { SLACK_WEBHOOKS  } from '../config';
import axios from 'axios';
import { history } from '../components/app';
import { SlackWebhook } from './utils';
import { UpdateLeadPassenger } from './passenger';


/**
 * UPDATE LEAD PASSENGER AND PAY via Busabout API
 * @param {string} bookingGroup - the booking group
 * @param {object} form - the booking group
 */
 export function UpdatePaxPay(bookingGroup, form, currency, amount, tmsFields){

   const payload = UpdateLeadPassenger(bookingGroup, form);
   const bookingURL = `${process.env.REACT_APP_BOOKING_API}/${bookingGroup.group_booking_id}?api_token=${process.env.REACT_APP_API_TOKEN}&booking_id=${bookingGroup.group_booking_id}&lead=1`;

    const config = {
      headers:{
         'Content-Type': 'text/plain'
      },
      withCredentials: true
    };


   return (dispatch) => {

     axios.put(bookingURL, payload, config)
       .then((response) => {
          if(response.data){
            dispatch({type:UPDATE_LEAD_PAX_SUCCESS, payload:true});
            dispatch(Payment(bookingGroup.group_booking_id, currency, amount, bookingGroup.session_id, tmsFields));
          }
       })
       .catch((err) => {
         console.error(err);
         dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Booking API (PUT) - ' + bookingURL + " " + err}));
         history.push('/500');
         dispatch({type:UPDATE_LEAD_PAX_FAIL, payload:false});
       });

   }
 }


/**
 * PAYMENT via Busabout API
 * @param {string} bookingGroupId - the booking id.
 * @param {string} currency - currency (GBP, AUD, USD, CAD).
 * @param {int} amount - money amount (00.00)
 * @param {string} guid - the booking GUID
 * @param {string} tmsFields - all the tms required fields
 */
export function Payment(bookingGroupId, currency, amount, tokenGuid, tmsFields){

  // WINDOW REDIRECT
  return dispatch => {
      window.location.href = `${process.env.REACT_APP_PAYMENT_API}?currency=${currency}&reference_number=${bookingGroupId}&amount=${amount}&guid=${tokenGuid}&api_token=${process.env.REACT_APP_API_TOKEN}&${tmsFields}`;
  }

  //POST
  // return dispatch => {
  //     axios.post(`${PAYMENT_API}?currency=${currency}&reference_number=${bookingGroupId}&amount=${amount}&guid=${tokenGuid}&api_token=${process.env.REACT_APP_API_TOKEN}&${tmsFields}`)
  //     .then(response => {
  //
  //     })
  //     .catch(err => {
  //       // dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! PAYMENT API - ' + `${PAYMENT_API}` + " " + err}));
  //       console.log(err);
  //     })
  // }
}



// WEBPACK FOOTER //
// ./src/actions/payment.js